//import React, { useState, useEffect } from 'react';
//import authService from './api-authorization/AuthorizeService'
//import DownloadRecords from './DownloadRecords';
//import SearchLogs from './SearchLogs'; 
//import GameImportRecords from './GameImportRecords';
//import DBUpdateRecords from './DBUpdateRecords';
//import SelectUser from './SelectUser';
//import AdvancedGameSearch from './features/games/AdvancedGameSearch';

//export default function AdminCenter(props) {
//    const [authenticated, setAuthenticated] = useState(false);
//    const [isAdmin, setIsAdmin] = useState(false);
//    const [isOrganizer, setIsOrganizer] = useState(false);
//    const [isPlayer, setIsPlayer] = useState(false);
//    const [userName, setUserName] = useState("");
//    const [idType, setIdType] = useState("");
//    const [playerId, setPlayerId] = useState("");
//    const [userRole, setUserRole] = useState("");

//    useEffect(() => {
//        async function effectFunc() {
//            setAuthenticated(await authService.isAuthenticated());
//            var user = await authService.getUser();
//            if (user != null) {
//                var role = user.role;
//                setUserName(user.sub);
//                if (user.sub.includes("FIDE")) {
//                    setIsPlayer(true);
//                    setIdType("FIDE");
//                    setPlayerId(user.sub.replace("FIDE", ""));
//                } else if (user.sub.includes("Affiliate")) {
//                    setIsPlayer(false);
//                    setIsOrganizer(true);
//                }
//                else if (user.sub.includes("USCF")) {
//                    setIsPlayer(true);
//                    setIdType("USCF");
//                    setPlayerId(user.sub.replace("USCF", ""));
//                }

//                setUserRole(role);
//                if (role.includes("Administrators"))
//                    setIsAdmin(true);
//            }
//        }
//        effectFunc();
//    }, []);

//        return (
//            <div>
//                {isAdmin &&
//                    <div>
//                        <DownloadRecords />
//                        <GameImportRecords />
//                        <SelectUser/>
//                        <DBUpdateRecords/>
//                        <SearchLogs />
//                        <AdvancedGameSearch />
//                    </div>
//                }
//            </div>
//        );
//}
import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, useTheme } from '@mui/material';
import authService from './api-authorization/AuthorizeService';
import DownloadRecords from './DownloadRecords';
import SearchLogs from './SearchLogs';
import GameImportRecords from './GameImportRecords';
import DBUpdateRecords from './DBUpdateRecords';
import SelectUser from './SelectUser';
import AdvancedGameSearch from './features/games/AdvancedGameSearch';

export default function AdminCenter(props) {
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState("");
    const [idType, setIdType] = useState("");
    const [playerId, setPlayerId] = useState("");
    const [userRole, setUserRole] = useState("");
    const [selectedTab, setSelectedTab] = useState(0);

    const theme = useTheme();

    useEffect(() => {
        async function effectFunc() {
            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("FIDE")) {
                    setIsPlayer(true);
                    setIdType("FIDE");
                    setPlayerId(user.sub.replace("FIDE", ""));
                } else if (user.sub.includes("Affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("USCF")) {
                    setIsPlayer(true);
                    setIdType("USCF");
                    setPlayerId(user.sub.replace("USCF", ""));
                }

                setUserRole(role);
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }
        }
        effectFunc();
    }, []);

    const tabs = [
        { label: "Download Records", component: <DownloadRecords /> },
        { label: "Import Records", component: <GameImportRecords /> },
        { label: "User List", component: <SelectUser /> },
        { label: "Player DB Updates", component: <DBUpdateRecords /> },
        { label: "Search Logs", component: <SearchLogs /> },
        { label: "Advanced Game Search", component: <AdvancedGameSearch /> },
    ];

    return (
        <div>
            {isAdmin && (
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                    {/* Tabs Navigation */}
                    <Tabs
                        value={selectedTab}
                        onChange={(event, newValue) => setSelectedTab(newValue)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            backgroundColor: theme.palette.background.default,
                        }}
                    >
                        {tabs.map((tab, index) => (
                            <Tab
                                key={tab.label}
                                label={tab.label}
                                sx={{
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    mx: 1,
                                    textTransform: 'none',
                                    backgroundColor: selectedTab === index
                                        ? theme.palette.primary.main
                                        : theme.palette.background.paper,
                                    color: selectedTab === index
                                        ? theme.palette.primary.contrastText
                                        : theme.palette.text.primary,
                                    '&:hover': {
                                        border: `1px solid ${theme.palette.primary.main}`,
                                    },
                                    '&.Mui-selected': {
                                        color: theme.palette.primary.contrastText,
                                    },
                                }}
                            />
                        ))}
                    </Tabs>

                    {/* Tab Content */}
                    <Box sx={{ flexGrow: 1, overflow: 'auto', p: 3 }}>
                        {tabs[selectedTab]?.component}
                    </Box>
                </Box>
            )}
        </div>
    );
}
